import { Component } from '@angular/core';
import { EsslService } from '../../../services/essl/essl.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-day-absentees',
  imports: [],
  templateUrl: './day-absentees.component.html',
  styleUrl: './day-absentees.component.css'
})
export class DayAbsenteesComponent {

   attDatePostForm = {
    searchDate: '',
    branchName: ''
  };
  employeeAttendance: any[] = []; // Array to hold employee attendance data
  selectedDate: string = '';
  teachingPresenties: any[] = [];
  nonTeachingPresenties: any[] = [];
  teachingAbsentees: any[] = [];
  nonTeachingAbsentees: any[] = [];

   constructor(private esslService: EsslService) { 
      // Initialization logic can go here
    }
  ngOnInit() {
     const today = new Date().toISOString().split('T')[0];
    this.onDateSelected(today);
  }
  onDateSelected(date: string) {
    this.selectedDate = date;
    // this.attDatePostForm.searchDate = date; // Update the search date in the form
    this.fetchEmployeeAttendance(date); // Fetch attendance data for the selected date
  } 

    fetchEmployeeAttendance(date: string) {
    const token = localStorage.getItem('authToken');
    this.teachingPresenties = [];
    this.nonTeachingPresenties = [];
    this.teachingAbsentees = [];
    this.nonTeachingAbsentees = [];
    // Clear previous data
    this.employeeAttendance = []; // Clear previous attendance data
    if (token) {
      this.attDatePostForm.searchDate = date; // Set default date to today
      // this.attDatePostForm.attDate = '16-07-2025'
      const decodedToken: any = jwtDecode(token) as { role: string, dept: string };
      const deptAcronym = decodedToken?.dept;
      this.attDatePostForm.branchName = deptAcronym; // Set default branch name
      console.log('Department Acronym:', deptAcronym);
      console.log('Decoded Token:', decodedToken);
      console.log('Attendance Date:', this.attDatePostForm.searchDate);
      this.esslService.getEmployeeAttendance(this.attDatePostForm).subscribe(
        data => {
          // const teachingOrder = ['Professor & Head','Professor', 'Associate Professor','Assistant Professor (Sr.)', 'Assistant Professor'];
          // const nonTeachingOrder = ['Web Designer','ASP Developer','Software Developer','Technical Support Engineer','Instrument Mechanic','Computer Assistant', 'Lab Assistant','Lab Technician','DEO cum Jr. Asst.','Data Entry Operator', 'Attender'];
          const teachingDesignationRank: { [key: string]: number } = {
             'Principal': 1,
      'Professor & Head': 2,
      'Assoc. Prof. & Head': 3,
      'Professor': 4,
      'Associate Professor': 5,
      'Assistant Professor (Sr.)': 6,
      'Assistant Professor': 7
          };
  
          const nonTeachingDesignationRank: { [key: string]: number } = {
      'Web Designer': 1,
      'Technical Support Engineer': 2,
      'ASP Developer': 3,
      'Software Developer': 4,
      'Office Superintendent': 5,
      'Superintendent': 6,
      'Project Assistant': 7,
      'Computer Assistant': 8,
      'Lab Assistant': 9,
      'Lab Technician': 10,
      'DEO cum Jr. Asst.': 11,
      'Junior Assistant': 12,
      'Steno': 13,
      'Data Entry Operator': 14,
      'Instrument Mechanic': 15,
      'Power House Technician': 16,
      'Lab Attender': 17,
      'Attender': 18
          };
          const designationCategoryMap: { [key: string]: 'Teaching' | 'Non-Teaching' } = {
      'Principal': 'Teaching',
      'Professor & Head': 'Teaching',
      'Professor': 'Teaching',
      'Associate Professor': 'Teaching',
      'Assistant Professor (Sr.)': 'Teaching',
      'Assistant Professor': 'Teaching',
      'Assoc. Prof. & Head': 'Teaching',
      'Office Superintendent': 'Non-Teaching',
      'Superintendent': 'Non-Teaching',
      'Web Designer': 'Non-Teaching',
      'ASP Developer': 'Non-Teaching',
      'Software Developer': 'Non-Teaching',
      'Technical Support Engineer': 'Non-Teaching',
      'Instrument Mechanic': 'Non-Teaching',
      'Project Assistant': 'Non-Teaching',
      'Junior Assistant': 'Non-Teaching',
      'Steno': 'Non-Teaching',
      'Computer Assistant': 'Non-Teaching',
      'Lab Assistant': 'Non-Teaching',
      'Lab Technician': 'Non-Teaching',
      'Lab Attender': 'Non-Teaching',
      'Power House Technician': 'Non-Teaching',
      'DEO cum Jr. Asst.': 'Non-Teaching',
      'Data Entry Operator': 'Non-Teaching',
      'Attender': 'Non-Teaching'
          };
  
    data.forEach(emp => {
    const designation = emp.designation?.trim();
    emp.category = designationCategoryMap[designation] || 'Other';
  });
          // Add category field to each record
            // data.forEach(emp => {
            //   if (teachingOrder.includes(emp.designation.trim())) {
            //     emp.category = 'Teaching';
            //   } else if (nonTeachingOrder.includes(emp.designation.trim())) {
            //     emp.category = 'Non-Teaching';
            //   } else {
            //     emp.category = 'Other';
            //   }
            // });
  
          // Filter and sort teaching presenties
          this.teachingPresenties = data
            .filter(emp => emp.attendanceStatus?.toLowerCase() === 'present' && emp.category === 'Teaching')
            .sort((a, b) => {
              // const desigCompare = teachingOrder.indexOf(a.designation) - teachingOrder.indexOf(b.designation);
              const desgA = a.designation?.trim() || '';
              const desgB = b.designation?.trim() || '';
              // Use the rank map to determine the rank of each designation
              const rankA = teachingDesignationRank[desgA] || 999;
              const rankB = teachingDesignationRank[desgB] || 999;
              if (rankA !== rankB) return rankA - rankB; // Sort by rank
              return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
              // if (desigCompare !== 0) return desigCompare;
              // return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
            });
            this.employeeAttendance = data; // Store the fetched data in the component property
          // Filter and sort non-teaching presenties
          this.nonTeachingPresenties = data
            .filter(emp => emp.attendanceStatus?.toLowerCase() === 'present' && emp.category === 'Non-Teaching')
            .sort((a, b) => {
              // const desigCompare = nonTeachingOrder.indexOf(a.designation) - nonTeachingOrder.indexOf(b.designation);
              const desgA = a.designation?.trim() || '';
              const desgB = b.designation?.trim() || '';
  
              const rankA = nonTeachingDesignationRank[desgA] || 999;
              const rankB = nonTeachingDesignationRank[desgB] || 999;
  
              if (rankA !== rankB) return rankA - rankB; // Sort by rank
              return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
              // if (desigCompare !== 0) return desigCompare;
              // return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
            });
  
          // Filter and sort teaching absentees
          this.teachingAbsentees = data
            .filter(emp => emp.attendanceStatus?.toLowerCase() === 'absent' && emp.category === 'Teaching')
            .sort((a, b) => {
              // const desigCompare = teachingOrder.indexOf(a.designation) - teachingOrder.indexOf(b.designation);
              const desgA = a.designation?.trim() || '';
              const desgB = b.designation?.trim() || '';
              const rankA = teachingDesignationRank[desgA] || 999;
              const rankB = teachingDesignationRank[desgB] || 999;
              if (rankA !== rankB) return rankA - rankB; // Sort by rank
              // return desigCompare;
              return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
              // if (desigCompare !== 0) return desigCompare;
              // return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
            });
  
          // Filter and sort non-teaching absentees
          this.nonTeachingAbsentees = data
            .filter(emp => emp.attendanceStatus?.toLowerCase() === 'absent' && emp.category === 'Non-Teaching')
            .sort((a, b) => {
              // const desigCompare = nonTeachingOrder.indexOf(a.designation) - nonTeachingOrder.indexOf(b.designation);
              const desgA = a.designation?.trim() || '';
              const desgB = b.designation?.trim() || '';
              const rankA = nonTeachingDesignationRank[desgA] || 999;
              const rankB = nonTeachingDesignationRank[desgB] || 999;
              if (rankA !== rankB) return rankA - rankB; // Sort by rank
              // return desigCompare;
              return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
              
              // if (desigCompare !== 0) return desigCompare;
              // return parseInt(a.employeeCode || '0') - parseInt(b.employeeCode || '0');
            });
  
          console.log('Employee Attendance Data:', data);
        },
        error => {
          console.error('Error fetching employee attendance:', error);
        }
      );
    }
  }

}
